
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/property-damage-guarantee",
      function () {
        return require("private-next-pages/terms/property-damage-guarantee/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/property-damage-guarantee"])
      });
    }
  